import React from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
} from '../../components/index';

const ListaEncerramentoExigencias = (props) => {
  if (!props.exigencias || props.exigencias.length === 0) {
    return null;
  }

  const trataAlteracaoNaExigencia = (e, atributo, tipoExigencia, codigoDependente) => {
    props.handlePositionalChange(e, atributo, tipoExigencia, codigoDependente);
  };

  const motivosNaoCumprimento = props.motivosNaoCumprimento.map(motivo => motivo);

  const montaExigencia = (exigencia, index) => (
    <React.Fragment>
      <p><b>{index + 1} - {exigencia.acao}</b></p>
      {exigencia.comentario ? (<p><b>Comentário:</b> {exigencia.comentario}</p>) : ''}
      <div className="row">
        <Grid cols="8 8 8 8">
          <Input
            number
            itemList={motivosNaoCumprimento}
            label="Motivo de não cumprimento"
            // label={`Motivo de não cumprimento - ${exigencia.codigoDependente}`}
            onChange={e => trataAlteracaoNaExigencia(e, 'motivoNaoAtendimento', exigencia.tipo, exigencia.codigoDependente)}
            placeholder="Selecione o Motivo"
            value={exigencia.motivoNaoAtendimento}
            custom
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="8 8 8 8">
          <Input
            cols="74"
            componentClass="textarea"
            label="Comentário para não cumprimento"
            // label={`Comentário para não cumprimento - ${exigencia.codigoDependente}`}
            maxlength="610"
            onChange={e => trataAlteracaoNaExigencia(e, 'comentarioNaoAtendimento', exigencia.tipo, exigencia.codigoDependente)}
            rows="5"
            value={exigencia.comentarioNaoAtendimento}
            textarea
          />
        </Grid>
      </div>
    </React.Fragment>
  );
  // Vinicius
  const listaExigencias = props.exigencias.map((exigencia, index) => (
    montaExigencia(exigencia, index)
  ));
  return (
    <ul>
      {listaExigencias}
    </ul>
  );
};

ListaEncerramentoExigencias.propTypes = {
  exigencias: PropTypes.arrayOf(PropTypes.object).isRequired,
  handlePositionalChange: PropTypes.func.isRequired,
  motivosNaoCumprimento: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ListaEncerramentoExigencias;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/ListaEncerramentoExigencias.jsx